import { PackageProviderName } from 'data/ppoints/constants';
import { usePPointsFeatures } from 'hooks/ppoints/usePPointsFeatures';
import { usePackageProviders } from 'hooks/usePackageProviders';
import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import { useMemo } from 'react';
import { PackageProviderFeature } from '../../../../../../../pb/responses/v1/package_provider_features_response_pb';
import { HOME_DELIVERY_AVAILABLE_PROVIDERS } from 'data/ppoints/home-delivery-available-providers';

export interface TileHide {
    tile1: boolean;
    tile2: boolean;
    tile3: boolean;
    tile4: boolean;
    tile5: boolean;
    tile6: boolean;
}

export const useTileHide = (provider?: PackageProviderName, integrationMode?: IntegrationModeSetting): TileHide => {
    const { packageProviders } = usePackageProviders();

    const providerId = useMemo(
        () => packageProviders?.find((p) => p.name === provider)?.id,
        [packageProviders, provider]
    );

    const providerIds = useMemo(() => (providerId ? [providerId] : []), [providerId]);
    const { data: features, isLoading: isLoadingFeatures } = usePPointsFeatures(providerIds);

    const hasLabelFeature = useMemo(() => {
        if (!providerId || isLoadingFeatures || !features?.data) return undefined;

        const entry = features.data.find((item) => Number(item.packageProviderId) === providerId);

        return entry ? entry.features.includes(PackageProviderFeature.LABEL) : undefined;
    }, [features, isLoadingFeatures, providerId]);

    return useMemo(() => {
        return {
            tile1: false,
            tile2: false,
            tile3: !(integrationMode === IntegrationModeSetting.map),
            tile4: !(integrationMode !== IntegrationModeSetting.checkout),
            tile5: HOME_DELIVERY_AVAILABLE_PROVIDERS.includes(provider) === false,
            tile6: hasLabelFeature === false,
        };
    }, [hasLabelFeature]);
};
